export enum SignupTargets {
    HOMEOWNER = 'homeowner',
    BOARD_MEMBER = 'self-managed',
    PROPERTY_MANAGER = 'property-manager',
}
